var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-top-top",on:{"click":function($event){return _vm.backToTop()}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p')])
}]

export { render, staticRenderFns }